// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__KVdiC","modalContainer":"Modal_modalContainer__SP3Ml","buttons":"Modal_buttons__Wi-T9"};